import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import CSSZSickLeaveCertificateAttendingDoctorReport from './CSSZSickLeaveCertificateAttendingDoctorReport';
import { CSSZSickLeaveCertificate } from '../../Interfaces/CSSZ.interface';
import { Size } from '../../../../Enums/Size.enum';
import { DeepPartial } from '../../../../Interfaces/DeepPartial';
import { CSSZSickLeaveCertificateAttendingDoctorReportFormValues } from './CSSZSickLeaveCertificateAttendingDoctorReportForm';

interface Props extends BaseModalProps {
	item: CSSZSickLeaveCertificate;
	defaultValues?: DeepPartial<CSSZSickLeaveCertificateAttendingDoctorReportFormValues>;
	patientId: string;
	onCreate: () => void;
}

const CSSZSickLeaveCertificateAttendingDoctorReportModal: React.FC<
	Props
> = props => {
	return (
		<BaseModal
			{...props}
			title='component.CSSZSickLeaveCertificateAttendingDoctorReport.modalTitle'
			size={Size.LG}>
			<CSSZSickLeaveCertificateAttendingDoctorReport
				item={props.item}
				patientId={props.patientId}
				onCreate={props.onCreate}
				defaultValues={props.defaultValues}
			/>
		</BaseModal>
	);
};

export default CSSZSickLeaveCertificateAttendingDoctorReportModal;
